import { DataTablePresenter, ProviderClaim } from '@enter/core';
import { ClaimActionButton } from 'components';
import _ from 'lodash';
import { claimsColumnsBase } from 'pages/main/claims';
import React, { useEffect } from 'react';
import { Row } from 'react-table';
import { useParams } from 'react-router-dom';
import { DialogProvider } from 'services';
import * as S from './details.styles';

interface IProps {
    claims: ProviderClaim[] | undefined;
}

const Component = ({ claims }: IProps) => {
    const { accountId } = useParams<{ accountId?: string }>();
    const { current: presenter } = React.useRef(
        new DataTablePresenter<ProviderClaim>({
            name: 'provider-guarantor-claims',
            data: claims || [],
            columns: [
                ...claimsColumnsBase,
                {
                    id: 'Action',
                    Header: '',
                    disableSortBy: true,
                    Cell: ({ row }): React.ReactElement => <ClaimActionButton claimId={row.original.id as string} />,
                },
            ],
            filterSchemas: [],
        }),
    );

    useEffect(() => {
        presenter.onDataUpdate(claims || []);
        presenter.onDataTotalChange(_.size(claims));
    }, [presenter, claims]);

    const getRowHref = (row: Row<ProviderClaim>): string => {
        return accountId ? `/${accountId}/claims/${row.original.id}` : `/claims/${row.original.id}`;
    };

    return (
        <S.StyledTitleCard size="large" info="Shows associated guarantor claims" title="Associated Claims">
            <S.StyledDataTable
                presenter={presenter}
                isLoading={!claims}
                disableSorting={true}
                hideFiltering={true}
                hideNavigation={true}
                getRowHref={getRowHref}
            />
        </S.StyledTitleCard>
    );
};

export const Claims = (props: IProps) => (
    <DialogProvider>
        <Component {...props} />
    </DialogProvider>
);
